"use client";

import { useWindowSize } from "@/hooks/useWindowSize";
import Image from "next/image";
import React from "react";
import dynamic from "next/dynamic";
const ZoomInWrapper = dynamic(() => import("../motion/ZoomInWrapper"));
const SlideInWrapper = dynamic(() => import("../motion/SlideInWrapper"));

const HeroSection = () => {
  const { width } = useWindowSize();
  let mobile = width < 1024;
  return (
    <section
      className={`hero-section max-w-full xs:max-w-[92vw] mx-auto xl:ml-auto w-full flex item-start justify-start px-6 xs:px-4 py-3 pb-0`}
    >
      <div
        className={`justify-between w-full mx-auto flex flex-wrap ${
          mobile ? "items-end" : "items-end"
        }`}
      >
        <div
          className={`${
            mobile ? "w-full h-fit" : "max-w-[40%] h-full"
          } flex flex-col justify-center ${mobile ? "items-center" : ""} `}
        >
          {mobile ? (
            <SlideInWrapper direction="left">
              {/* <div className="bg-blue-500 text-white py-1 mt-4 px-5 rounded-xs inline-block mb-6 font-bold text-sm max-w-fit">
                Made Especially for SSC CGL 2025 & 2026
              </div> */}
              <h1 className="text-md font-bold text-neutral-700 mb-1">
                Just 3 months to go?
              </h1>
              <h1 className="text-4xl font-extrabold">
                Practice.{" "}
                <span className="text-primary text-orange-600">Revise.</span>
                <br />
                Clear Tier 1.
              </h1>
            </SlideInWrapper>
          ) : (
            <SlideInWrapper direction="left">
              {/* <div className="bg-blue-500 text-white py-1 px-5 rounded-xs inline-block mb-6 font-bold text-sm max-w-fit">
                Made Especially for SSC CGL 2025 & 2026
              </div> */}
              <h1 className=" text-black text-5xl font-extrabold mb-1">
                Just 3 months to go?
              </h1>
              <h1 className="text-5xl font-extrabold">
                Practice.{" "}
                <span className="text-primary text-orange-600">Revise.</span>
                <br />
                Clear Tier 1.
              </h1>

              <p className="text-sm font-medium text-neutral-700 mt-5 mb-1 block">
                Join our <strong>AI Revision System</strong> for SSC Exams.
              </p>
              <p className="text-sm  font-medium text-neutral-700 mb-8 block">
                You will never forget what you practice here.
              </p>

              <div className="flex-col items-start block">
              <div className="flex items-center gap-3">
                <a
                  href="https://play.google.com/store/apps/details?id=app.netpractice.app&pcampaignid=web_share"
                  target="_blank"
                  aria-label="NetPractice | Google Play"
                  className="btn"
                  title="NetPractice | Google Play"
                >
                  <Image
                      src="/assets/startPage/Frame_1_GS.svg"
                      alt="Start Icon"
                      width={264}
                      height={64}
                      // className="mr-3"
                    />
                </a>
                {/* <a
                  href="#downloadApp"
                  aria-label="start revising"
                  className="btn"
                  title="start revising"
                >
                  <Image
                      src="/assets/startPage/Frame_1_AS.svg"
                      alt="Start Icon"
                      width={264}
                      height={64}
                      // className="mr-3"
                    />
                </a> */}
                </div>
                <p className="flex items-start justify-start mt-2 text-neutral-700 text-[11px] font-medium px-6">
                  Contains PYQs, Mock Tests for CGL 2025 & 2026
                </p>
              </div>
            </SlideInWrapper>
          )}
        </div>
        {mobile ? (
          <ZoomInWrapper className={"mt-2 w-full flex justify-center"}>
            <Image
              src="/assets/startPage/Frame_1A.svg"
              alt="week_streak"
              width={550}
              height={600}
              style={{ maxWidth: "100%", height: "auto" }}
              priority
            />
          </ZoomInWrapper>
        ) : (
          <SlideInWrapper
            direction="top"
            className={"mt-0 w-[60%] flex justify-end xl:justify-center"}
          >
            <Image
              src="/assets/startPage/Frame_1A.webp"
              alt="week_streak"
              width={740}
              height={898}
              unoptimized
              quality={100}
              priority
             
            />

            {/* <div className="w-full h-[100vh] flex justify-center items-center relative mt-10 lg:mt-0 lg:mb-0">
              <Image
                src="/assets/startPage/Frame_1AB.svg"
                alt="week_streak"
                width={200}
                height={200}
                className="absolute z-10"
                style={{
                  top: "-50px",
                  left: "40px",
                }}
              />
              <Image
                src="/assets/startPage/Frame_1AA.svg"
                alt="phone_hand"
                width={700}
                height={750}
                className="absolute z-100"
                style={{
                  top: "30px",
                  left: "160px",
                }}
              />
              <Image
                src="/assets/startPage/Frame_1AC.svg"
                alt="gold_revision"
                width={300}
                height={300}
                className="absolute z-10"
                style={{
                  top: "-15px",
                  left: "560px",
                }}
              />
              <Image
                src="/assets/startPage/Frame_1AD.svg"
                alt="trigo"
                width={300}
                height={300}
                className="absolute  z-101"
                style={{
                  bottom: "110px",
                  left: "110px",
                }}
              />
              <Image
                src="/assets/startPage/Frame_1AE.svg"
                alt="coin"
                width={150}
                height={150}
                className="absolute z-10"
                style={{
                  bottom: "280px",
                  right: "120px",
                }}
              />
            </div> */}
          </SlideInWrapper>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
